import { IDocumentFileModel } from '@api/models';
import { removeUserFromDocument } from '@api/services/document.service';
import { useMutation } from '@tanstack/react-query';

interface RemoveUserFromDocumentOptions {
    clientId: string;
    file: IDocumentFileModel;
}

const useRemoveUserFromDocumentForm = (options: RemoveUserFromDocumentOptions) => {
    const { file, clientId } = options;

    const removeUserFromDocumentMutation = useMutation((userId: string) =>
        removeUserFromDocument(clientId, file._id, userId)
    );

    const submit = async (value: string) => {
        await removeUserFromDocumentMutation.mutateAsync(value);
    };

    return {
        isLoading: removeUserFromDocumentMutation.isLoading,
        submit,
    };
};

export default useRemoveUserFromDocumentForm;
